import { Injectable } from '@angular/core';

//Trust cookie page
declare function reloadOTBanner(): any;
declare function initOTCookie(): any;

@Injectable({
  providedIn: 'root'
})
export class OneTrustService {

  constructor() { }

  initOneTrustCookie() {
    initOTCookie();
  }

  reloadOneTrustBanner() {
    reloadOTBanner();
  }
}
